import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CAL_DEMO_BOOKING_URL } from '@app/config';
import { StatisticsQueryService } from '@app/core';
import { environment } from '@env/environment';
import { TuiButton } from '@taiga-ui/core';
import { TuiBadge } from '@taiga-ui/kit';
import { RoughNotationModule } from 'ng-rough-notation';

@Component({
  selector: 'app-native-builds-hero-section',
  imports: [DecimalPipe, RoughNotationModule, TuiBadge, TuiButton],
  templateUrl: './native-builds-hero-section.component.html',
  styleUrl: './native-builds-hero-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NativeBuildsHeroSectionComponent {
  protected readonly bookingUrl = CAL_DEMO_BOOKING_URL;
  protected readonly consoleBaseUrl = environment.consoleBaseUrl;
  protected readonly statistics = this.statisticsQueryService.queryStatistics();

  constructor(
    private readonly statisticsQueryService: StatisticsQueryService,
  ) {}
}
